import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { DeviceExecutionCommand, DeviceId } from '../../site-detail/models/Device';
import { Execution } from '../../site-detail/models/Execution';
import { DEVICE_GATEWAY } from '../../site-detail/services/DeviceGateway';
import { addManualExecution } from '../../site-detail/store/actions/ui.actions';
import { AppState } from '../store/app-state';

import { UISocketService } from './ui.socket.service';

@Injectable()
export class DevicesAPI {
    private readonly deviceGateway = inject(DEVICE_GATEWAY);
    private readonly uiSocketService = inject(UISocketService);
    private readonly store = inject<Store<AppState>>(Store);

    executeCommand(deviceId: DeviceId, bodyReq: DeviceExecutionCommand): Observable<Execution> {
        return this.deviceGateway.executeCommand(deviceId, bodyReq).pipe(
            tap((exec: Execution) => {
                this.store.dispatch(addManualExecution({ exec }));
            }),
            tap((exec: Execution) => {
                // Tell the backend to track these job_id then he can tell about any change through websocket
                this.uiSocketService.setExecutions([exec.job_id]);
            }),
        );
    }
}
